import { useCallback } from "react";

import PropTypes from "prop-types";

import { apiClient } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const OutletWarehouseSelect = ({ outletId, ...props }) => {
  const fetchOutletWarehouses = useCallback(async () => {
    if (!outletId) return [];

    const {
      data: { data },
    } = await apiClient.get(`outlets/${outletId}/warehouses`, {
      // params: {
      //   status: StatusEnum.ACTIVE,
      // },
    });
    return data;
  }, [outletId]);

  return (
    <CustomAutocomplete
      fetchOptions={fetchOutletWarehouses}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
      TextFieldProps={{
        ...props?.TextFieldProps,
        InputProps: {
          ...(props.TextFieldProps?.InputProps || {}),
          placeholder:
            props.TextFieldProps?.InputProps?.placeholder || "Cari nama/kode",
        },
      }}
    />
  );
};

OutletWarehouseSelect.propTypes = {
  outletId: PropTypes.string,
  TextFieldProps: PropTypes.object,
};
